import { takeEvery, select, put, all } from 'redux-saga/effects';
import { setPropertyUWMarkerState, setAuctionUWMarkerState, setPostAcqUWMarkerState,
  setImagesCache, setImagesRequests, setPostAcqUWCompsImageCache, setPostAcqUWCompsImageRequests } from 'store/actions';
import { imagesSelector, imageRequestsSelector, postAcqUWCompsImageCacheSelector, postAcqUWCompsImageRequestsSelector } from 'store/selectors';
import { getUWPropertyImage, getGoogleImageUrls } from 'utilities/urls';
import { fullAddress } from 'utilities/address';

const getActions = underwriteType => {
  switch (underwriteType) {
    case 'auction':
      return;
    case 'acquisition':
      return {
        setMarkerStateAction: setPropertyUWMarkerState,
        setImageCacheAction: setImagesCache,
        setImageRequestsAction: setImagesRequests,
        imageCacheSelector: imagesSelector,
        imageRequestsSelector: imageRequestsSelector
      }
    case 'postAcquisition':
      return {
        setMarkerStateAction: setPostAcqUWMarkerState,
        setImageCacheAction: setPostAcqUWCompsImageCache,
        setImageRequestsAction: setPostAcqUWCompsImageRequests,
        imageCacheSelector: postAcqUWCompsImageCacheSelector,
        imageRequestsSelector: postAcqUWCompsImageRequestsSelector
      }
    default:
      return;
  }
}

function* getImageProcess(underwriteType, asgPropID, txnOpp) {
  const { setMarkerStateAction, setImageCacheAction, setImageRequestsAction, imageCacheSelector, imageRequestsSelector } = getActions(underwriteType);
  const imagesPreviousState = yield select(imageCacheSelector);
  const imageRequests = yield select(imageRequestsSelector);
  const getGoogleImageSource = (googleImageUrls) => {
		const images = [];
		if (googleImageUrls.streetViewUrl) {
			images.push({
				id: 1,
				caption: 'Street View',
				imageUrl: googleImageUrls.streetViewUrl,
				source: 'Google',
				sortOrder: 1
			});
		}
		images.push({
			id: images.length,
			caption: 'Satellite View',
			imageUrl: googleImageUrls.mapsStaticUrl,
			source: 'Google',
			sortOrder: images.length
		})
		const googleImageSource = {
			source: 'Google',
			images
		}
		return googleImageSource;
	};

  if (asgPropID) {
    if (!imagesPreviousState.hasOwnProperty(asgPropID)) {
      if (!imageRequests.includes(asgPropID)) {
        yield put(setImageRequestsAction([...imageRequests, asgPropID]));
        try {
          const [googleImageUrls, fetchedImages] = yield all([
            getGoogleImageUrls(fullAddress(txnOpp), 640, 360),        
            getUWPropertyImage(asgPropID, null, 'PropertyUWComp')
          ]);
          
          let propertyImageSources = [];
          if (fetchedImages) {
            propertyImageSources = [...fetchedImages];
          }
          // ImageUrls is an array of arrays of image strings. From Cameron, he says it was Ilya's explicit request to have the image string array into another array to have a historic image set
          // The first index of the ImageUrls array will always be the most recent image set.
          // Now images are coming as list of image dtos includes imageUrl and metadata about image from multiple resource like PIM, M3, S3. keeping above comments just for reference purposes 
          propertyImageSources.push(getGoogleImageSource(googleImageUrls));
         if(propertyImageSources) {
            var images = {};
            images[asgPropID] = propertyImageSources;
            yield put(setImageCacheAction({ ...images, ...imagesPreviousState }));
            yield put(setMarkerStateAction({ selectedMarkerImages: propertyImageSources, isFetchingImages: false }));
         }
        } catch (error) {
          console.log(error);
          // yield put(appNotify(error.message, 'error'));  // Don't show error snackback, already sending an email on error
          yield put(setImageRequestsAction(imageRequests.filter(r => r !== asgPropID)));
          yield put(setMarkerStateAction({ isFetchingImages: false }));
        }
      } else {
        //still waiting for API request
      }
    } else {
      // yield delay(200);   // giving a little time for the map to be able to pan to the pin
      yield put(setMarkerStateAction({ selectedMarkerImages: imagesPreviousState[asgPropID], isFetchingImages: false }));
    }
  } else {
    yield put(setMarkerStateAction({ selectedMarkerImages: [], isFetchingImages: false }));
  }
}

export function* getImagesSaga() {
  yield takeEvery(setAuctionUWMarkerState, function* ({ payload: auctionUWMarkerState }) {
    if (auctionUWMarkerState && auctionUWMarkerState.selectedMarker && auctionUWMarkerState.isFetchingImages) {
      const asgPropID = auctionUWMarkerState.selectedMarker.asgPropertyId || auctionUWMarkerState.selectedMarker.asgPropID;
      yield getImageProcess('auction', asgPropID, auctionUWMarkerState.selectedMarker);
    } else {
      if (auctionUWMarkerState.isFetchingImages && !auctionUWMarkerState.isInfoBoxOpen) {
        yield put(setAuctionUWMarkerState({ isFetchingImages: false }));
      }
    }
  });
  yield takeEvery(setPropertyUWMarkerState, function* ({ payload: propertyUWMarkerState }) {
    if (propertyUWMarkerState && propertyUWMarkerState.selectedMarker && propertyUWMarkerState.isFetchingImages) {
      const asgPropID = propertyUWMarkerState.selectedMarker.asgPropId || propertyUWMarkerState.selectedMarker.asgPropID;
      yield getImageProcess('acquisition', asgPropID, propertyUWMarkerState.selectedMarker);
    } else {
      if (propertyUWMarkerState.isFetchingImages && !propertyUWMarkerState.isInfoBoxOpen) {
        yield put(setPropertyUWMarkerState({ isFetchingImages: false }));
      }
    }
  });
  yield takeEvery(setPostAcqUWMarkerState, function* ({ payload }) {
    const { postAcqUWMarkerState } = payload;
    if (postAcqUWMarkerState && postAcqUWMarkerState.selectedMarker && postAcqUWMarkerState.isFetchingImages) {
      const asgPropID = postAcqUWMarkerState.selectedMarker.asgPropId || postAcqUWMarkerState.selectedMarker.asgPropID;
      yield getImageProcess('postAcquisition', asgPropID, postAcqUWMarkerState.selectedMarker);
    } else {
      if (postAcqUWMarkerState.isFetchingImages && !postAcqUWMarkerState.isInfoBoxOpen) {
        yield put(setPostAcqUWMarkerState({ isFetchingImages: false }));
      }
    }
  });
}
